var _rect, _circle, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrongCardNumber = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 44,
    fill: "#7B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8819 74H78.7845C79.7241 73.9989 80.6249 73.6624 81.2901 73.0645C81.9548 72.4662 82.3299 71.6552 82.3331 70.8085V56.5789C82.3332 56.5744 82.3333 56.5699 82.3333 56.5653V52.4349C82.3333 52.4303 82.3332 52.4258 82.3331 52.4212V49.1915C82.3299 48.3448 81.9548 47.5338 81.2901 46.9355C80.6248 46.3376 79.7241 46.0011 78.7845 46H41.8819C40.9424 46.0011 40.0415 46.3376 39.3764 46.9355C38.7116 47.5338 38.3365 48.3448 38.3333 49.1915V70.8085C38.3365 71.6552 38.7116 72.4662 39.3764 73.0645C40.0416 73.6624 40.9424 73.9989 41.8819 74ZM39.2386 57.0001V70.8093C39.2394 71.4408 39.5178 72.0464 40.0137 72.4929C40.5092 72.9397 41.1812 73.1906 41.882 73.1914H78.7845C79.4853 73.1906 80.1574 72.9397 80.6528 72.4929C81.1487 72.0464 81.4271 71.4409 81.4279 70.8093V57.0001H39.2386ZM39.2386 52.0001H81.4279V49.1923C81.4271 48.5608 81.1487 47.9552 80.6528 47.5087C80.1574 47.0619 79.4853 46.811 78.7845 46.8103L41.8819 46.8165C41.1824 46.8168 40.5116 47.0674 40.0161 47.5124C39.5207 47.9577 39.241 48.5619 39.2386 49.1923V52.0001ZM81.4279 52.8697H60.3335H39.2391V56.1305H81.4279V52.8697Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 49,
    width: 48,
    height: 9,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrongCardNumber);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrong-card-number.519ecf3ed7e613f4b27bbf0bc4aaa30f.svg";